import React, { useState } from 'react';
import { Form, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import api from '../../services/api';

const ResetPassword = () => {
  const [searchParams]            = useSearchParams();
  const token                     = searchParams.get('token');
  const navigate                  = useNavigate();

  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [loading, setLoading]     = useState(false);
  const [showPass, setShowPass]   = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirm) { toast.warning('Preencha todos os campos'); return; }
    if (password.length < 8)   { toast.warning('Mínimo 8 caracteres');       return; }
    if (password !== confirm)  { toast.warning('As senhas não coincidem');    return; }
    if (!token)                { toast.error('Token inválido');               return; }

    try {
      setLoading(true);
      await api.post('/auth/reset-password', { token, password });
      toast.success('Senha redefinida com sucesso!');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      const msg = err?.response?.data?.message || 'Token inválido ou expirado';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div style={{ fontSize: '48px' }}>❌</div>
          <h6 className="mt-3">Link inválido</h6>
          <Link to="/esqueci-senha" className="btn btn-outline-primary btn-sm mt-2">
            Solicitar novo link
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow-sm p-4" style={{ width: '100%', maxWidth: '420px' }}>

        <h5 className="fw-bold mb-1 text-center">🔒 Nova Senha</h5>
        <p className="text-muted text-center mb-4" style={{ fontSize: '14px' }}>
          Escolha uma senha forte com no mínimo 8 caracteres.
        </p>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Nova Senha</Form.Label>
            <div className="input-group">
              <Form.Control
                type={showPass ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Mínimo 8 caracteres"
                autoFocus
              />
              <Button
                variant="outline-secondary"
                type="button"
                onClick={() => setShowPass(p => !p)}
              >
                {showPass ? '🙈' : '👁️'}
              </Button>
            </div>
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label className="fw-semibold">Confirmar Senha</Form.Label>
            <Form.Control
              type={showPass ? 'text' : 'password'}
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              placeholder="Repita a senha"
              isInvalid={confirm.length > 0 && password !== confirm}
            />
            <Form.Control.Feedback type="invalid">
              As senhas não coincidem
            </Form.Control.Feedback>
          </Form.Group>

          <Button variant="primary" type="submit" className="w-100" disabled={loading}>
            {loading
              ? <><Spinner size="sm" className="me-2" />Salvando...</>
              : '✅ Redefinir Senha'
            }
          </Button>

          <div className="text-center mt-3">
            <Link to="/login" style={{ fontSize: '13px' }} className="text-muted">
              ← Voltar ao login
            </Link>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
